import React from "react";

interface RadioButtonProps {
  id: string;
  name?: string;
  value: string | boolean;
  label: string;
  checked: boolean;
  onChange?: (value: string | boolean) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  name,
  value,
  label,
  checked,
  onChange = () => {},
}) => {
  return (
    <div className="inline-flex">
      <label
        className="relative flex items-center gap-2 cursor-pointer"
        htmlFor={id}
      >
        <input
          name={name}
          type="radio"
          id={id}
          className="peer h-6 w-6 cursor-pointer appearance-none rounded-full border  border-[#EAECF0] checked:border-[#D1A960] transition-all"
          checked={checked}
          onChange={() => onChange(value)}
        />
        <span className="absolute bg-primary w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
      </label>
      <label
        className="ml-2 sm:ml-3 font-Mulish text-sm sm:text-base  text-darkgrey cursor-pointer"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
